import { commonTheme } from '~/theme/CommonTheming';
import { ThemeType } from '~/theme/Themes';

export const lightTheme: ThemeType = {
  name: 'Light',
  colors: {
    primaryLight: '#F5F9FF',
    p400: '#329AFC',
    secondary: '#DCF400',
    neon: '#11BA5D',
    background: '#FAFCFF',
    selection: '#F0F6FF',
    lightBlackBackground: '#223445',
    lightGreenBackground: '#ECF9F2',
    tableHeaderBackground: '#FBFBFB',
    secondaryGraph: '#329AFC',
    red: '#ED0A34',
    darkRed: '#EB4747',
    errorRed: '#F31260',
    softRed: '#E85C5C',
    warningYellow: '#FABF1C',
    success: '#3CA540',
    backgroundShadowGradientValue: '0 0 0 0 0.222444 0 0 0 0 0 0 0 0 0 0.433333 0 0 0 0.1 0',
    graph: [
      '#004688',
      '#005CB4',
      '#006CD2',
      '#1784EC',
      '#329AFC',
      '#87C5FF',
      '#C6E4FF',
      '#F5F9FF',
      '#FAFCFF',
      '#EAEAEA',
    ],
    primary: {
      c900: '#032745',
      c800: '#043D6C',
      c700: '#054880',
      c600: '#065EA7',
      c500: '#1784EC',
      c400: '#329AFC',
      c300: '#87C5FF',
      c200: '#C6E4FF',
      c100: '#F5F9FF',
      c050: '#FAFCFF',
    },
    neutrals: {
      black: '#2D2D2D',
      white: '#FFFFFF',
      c500: '#575757',
      c400: '#818181',
      c300: '#A8A8A8',
      c200: '#D5D5D5',
      c100: '#EAEAEA',
      c050: '#F4F4F4',
    },
    system: {
      error: {
        c800: '#750E13',
        c700: '#A2191F',
        c600: '#DA1E28',
        c500: '#ef4444',
        c400: '#FA4D56',
        c300: '#FF8389',
        c200: '#FFB3B8',
        c100: '#FFD7D9',
        c050: '#FFF1F1',
      },
      warning: {
        c500: '#eab308',
        c300: '#fde047',
        c100: '#fef9c3',
      },
      success: {
        c900: '#022D0D',
        c800: '#044317',
        c700: '#0E6027',
        c600: '#198038',
        c500: '#24A148',
        c400: '#42BE65',
        c300: '#6FDC8C',
        c200: '#A7F0BA',
        c100: '#D1FAE5',
        c050: '#EDFDF5',
      },
      information: {
        c500: '#3b82f6',
        c300: '#bfdbfe',
        c100: '#dbeafe',
      },
      overlay: 'rgba(156, 163, 175, 0.4)',
    },
    modal: {
      background: '#C6E4FF',
      startGradient: '#005CB4',
      endGradient: '#1784EC',
    },
    aiOrange: '#ff6c0a',
    graphHighlight: { max: '#FF822F', min: '#FF99A5' },
  },
  gradients: {
    primary: 'linear-gradient(90deg, #005CB4 -0.29%, #1784EC 100%)',
    overflowGradient: 'linear-gradient(270deg, #ffffff 0%, #ffffff00 100%)',
    shimmer: 'linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%)',
    shimmerDark: 'linear-gradient(to right, #D4D8DE 8%, #E1E3E7 18%, #D4D8DE 33%)',
    welcome: 'linear-gradient(322.22deg, #005Cb4 52.87%, #1784EC 100%)',
    selection:
      'linear-gradient(90deg, rgba(23, 132, 236, 0.12) 0%, rgba(23, 132, 236, 0.09) 43.87%, rgba(23, 132, 236, 0.06) 100%)',
    activationsBannerGradient: 'linear-gradient(180deg, rgba(198, 228, 255, 0.70) 0%, rgba(255, 255, 255, 0.00) 100%)',
    activeIntegrationGradient: 'linear-gradient(90deg, #005CB4 -0.29%, #1784EC 100%)',
    aiInsights: 'linear-gradient(99deg, #1784ec 1.34%, #ff8fa1 48.89%, #ff6c0a 96.43%)',
    aiInsightsAnimated:
      'linear-gradient(99deg, #1784ec 0.67%, #ff8fa1 24.45%, #ff6c0a 48.22%, #1784ec 50.67%, #ff8fa1 74.45%, #ff6c0a 98.22%)',
    askAiBorderAnimated: 'conic-gradient(from var(--border-angle), #1784ec 0%, #ff8fa1 33%, #ff6c0a 66%, #1784ec 100%)',
  },
  fonts: {
    primary: 'Inter',
    secondary: 'Titillium Web',
  },
  borderRadius: '6px',
  ...commonTheme,
};

export const darkTheme: ThemeType = {
  ...lightTheme,
  name: 'Dark',
  gradients: {
    ...lightTheme.gradients,
    shimmer: 'linear-gradient(to right, #4a5064 8%, #3c4456 18%, #4a5064 100%)',
  },
};
